﻿import {Cookies, isNullOrEmpty, StringNamedValue, translation} from "@2d-front-monorepo/core";
import {Select} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {getGlobalContext} from "../hooks/getGlobalContext";
import {JSX} from "react";

const availableLanguages: StringNamedValue[] = [
	{
		label: "Español (España)",
		value: "es-ES"
	},
	{
		label: "English",
		value: "en-US"
	},
	{
		label: "Français",
		value: "fr-FR"
	},
	{
		label: "Català (Espanya)",
		value: "ca-ES"
	},
	{
		label: "Español (México)",
		value: "es-MX"
	},
	{
		label: "Italiano (Italia)",
		value: "it-IT"
	},
	{
		label: "Español (Argentina)",
		value: "es-AR"
	},
	{
		label: "Español (Venezuela)",
		value: "es-VE"
	}
];

export type LanguageSelectorProps = {
	hidden?: boolean;
};

export function LanguageSelector(props: LanguageSelectorProps): JSX.Element {
	const {hidden} = props;
	const {installation} = getGlobalContext();

	if (hidden || installation.languages.length <= 1) {
		return <></>;
	}

	const filteredLanguages = availableLanguages.filter(lang =>
		installation.languages.includes(lang.value as any)
	);

	let languageId = Cookies.get("language");
	if (isNullOrEmpty(languageId)) {
		languageId = installation.languages[0];
	}

	return <div className={"language-selector"}>
		<Select label={translation(PermitTranslations.language_selector__label)} name={"language"} items={filteredLanguages} value={languageId} onChange={(e) => {
			Cookies.set("language", e.currentTarget.value, "none");
			location.replace("/");
		}}/>
	</div>;
}
